import React from 'react';
import { Segment, Divider } from 'semantic-ui-react';
import { SemanticContainer, SemanticSegment } from './styled';

import { withRouter } from 'react-router-dom';
import AdminMenu from '../../../../../components/Admin/MenuDetalhes/AdminMenu'
import Back from '../../../../../components/Admin/Pocketbook/Cupons/Criar/Back';
import Formulario from '../../../../../components/Admin/Pocketbook/Cupons/Criar/Formulario';

const CuponsCriarPocket = props => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Criar Cupom</h2>
        <Divider />
        <Segment>
          <Formulario props={props}/>
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment >
          Grupo Voitto <i class="copyright outline icon"></i>2021
        </SemanticSegment>
      </SemanticContainer>
    </>
  )
}

export default withRouter(CuponsCriarPocket);